<div class="card">
    <div class="card-header">
        Shift Mapping
    </div>
    <div class="card-body">
        <div class="row m-1" *ngIf="!ViewMode">
            <div class="col-md-5 px-1">
                <label class="Label1">Shift</label>
                <ng-select name="Shift" [items]="Shift" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                    [(ngModel)]="ShiftID" (change)="onSelectChange('Shift')" placeholder="Select Shift">
                    <ng-option *ngFor="let segment of Shift" [value]="segment.ShiftMasterID">
                        {{ segment.ShiftTitle }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-5 px-1">
                <label class="Label1">No Of Employee</label>
                <input name="employe" style="text-align: right;" [(ngModel)]="NoOfEmp" type="number"
                    class="form-control" />
            </div>
            <div class="col-md-2 px-1"><br>
                <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="add()">
                    <i class="bi bi-plus" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'add':'Loading...'}}
                </button>
            </div>
        </div>
        <div class="card-body p-1" style="overflow: auto;">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Shift ID</th>
                        <th scope="col">Shift Title</th>
                        <th scope="col">No of Employees</th>
                        <th scope="col" *ngIf="!ViewMode && !AddShiftonly">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let shift of ShiftTable; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ shift.ShiftId }}</td>
                        <td>{{ shift.ShiftTitle }}</td>
                        <td style="text-align: center;">{{ shift.NoOfEmp }}</td>
                        <td *ngIf="!ViewMode && !AddShiftonly"><button class="btn btn-sm" (click)="deleteRow(i)" style="color: red">
                                <i class="bi bi-trash-fill"></i>
                            </button></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">

                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="Cancel()">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
                &nbsp;
                <button type="button" *ngIf="!ViewMode" class="btn btn-primary" [disabled]="isDisabled"
                    (click)="onOkClick()">
                    <i class="bi bi-person-add" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Ok':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>